import React from 'react';
import { IconProps } from '../types/types';

const TWTR: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="url(#a14u0rcug)" d="M0 0h18v18H0z"/><path d="M9.76 8.44 12.74 5h-.7l-2.6 3-2.06-3H5l3.12 4.5L5 13h.7l2.74-3.05L10.62 13H13L9.76 8.44Zm-.96 1.1-.32-.44-2.52-3.57h1.08l2.04 2.89.31.44 2.64 3.6h-1.08L8.8 9.55Z" fill="#fff"/><defs><linearGradient id="a14u0rcug" x1="3.35" y1="3.12" x2="21.9" y2="24.43" gradientUnits="userSpaceOnUse"><stop stopColor="#1A1E21"/><stop offset="1" stopColor="#06060A"/></linearGradient></defs></svg>
);

export default TWTR;